<script lang="ts">
  export let size = 16;
</script>

<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12.6264 2.33325H3.37305C3.09971 2.33325 2.87305 2.10659 2.87305 1.83325C2.87305 1.55992 3.09971 1.33325 3.37305 1.33325H12.6264C12.8997 1.33325 13.1264 1.55992 13.1264 1.83325C13.1264 2.10659 12.8997 2.33325 12.6264 2.33325Z"
    class={$$props.class || "fill-current"}
  />
  <path
    d="M12.6264 14.6667H3.37305C3.09971 14.6667 2.87305 14.4401 2.87305 14.1667C2.87305 13.8934 3.09971 13.6667 3.37305 13.6667H12.6264C12.8997 13.6667 13.1264 13.8934 13.1264 14.1667C13.1264 14.4401 12.8997 14.6667 12.6264 14.6667Z"
    class={$$props.class || "fill-current"}
  />
  <path
    d="M1.83398 5.33325V10.6666C1.83398 11.7733 2.72732 12.6666 3.83398 12.6666H12.1673C13.274 12.6666 14.1673 11.7733 14.1673 10.6666V5.33325C14.1673 4.22659 13.274 3.33325 12.1673 3.33325H3.83398C2.72732 3.33325 1.83398 4.22659 1.83398 5.33325Z"
    class={$$props.class || "fill-current"}
  />
</svg>
